/**
 * Builds a clean filename from a string or an array of strings by removing accents and others special characters.
 *
 * @see https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
 */
export const buildCleanFileName = (input: string|string[], separator: string = '_'): string => {
    if (!input) {
        return '';
    }

    const value = Array.isArray(input) ? input.filter(Boolean).join(separator) : input;

    return value
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9-_]/g, "_")
        .replace(/_+/g, "_")
        .toLowerCase()
        .trim();
};

/**
 * Download any type of file directly in the browser.
 */
export const downloadFile = (data: any, filename: string, mimeType: string = 'application/octet-stream') => {
    const blob = data instanceof Blob ? data : new Blob([data], { type: mimeType });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
};

/**
 * Reads a single Blob object and converts it to a Base64 encoded string.
 */
export const readFileAsBase64 = (file: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
};

/**
 * Converts an array of Blob objects into an array of Base64 encoded strings.
 */
export const convertFilesToBase64 = (files: Blob[]): Promise<string[]> => {
    return Promise.all(files.map(readFileAsBase64));
};
